<template>
  <section v-if="products.length" class="">
    <div class="container-lg">
      <div class="section__header  mb-3">
        <h2 class="mb-[24px] text-heading-2">
        {{ splitTitle(in18['page_linked_products'])?.first }}
          <span :class="[theme === 'green' && 'text-lime-green ', theme === 'pink' && 'text-hot-pink ', theme === 'amber' && 'text-amber ', theme === 'sky' && 'text-sky-blue ']">
            {{ splitTitle(in18['page_linked_products'])?.last }}
          </span>
        </h2>
        <!-- Line after subtitle -->
        <div class="w-full h-1 border-b border-light-gray/25">
          <div class="w-[56%] md:w-[19%] h-1" :class="[theme === 'green' && 'bg-lime-green ', theme === 'pink' && 'bg-hot-pink ', theme === 'amber' && 'bg-amber ', theme === 'sky' && 'bg-sky-blue ']">
          </div>
        </div>
      </div>

      <div class="variations-table">
        <div v-for="product in products" class="variations-table__row">
          <div class="variations-table__col">
            <div class="variations-table__data">
              <img :src="product.image.source"
                   :alt="product.title"
                   class="variations-table__image"
                   height="75"
                   width="75"
              >
              <div>
                <div class="variations-table__title">
                  {{ product.title }}
                  <div>{{ product.code }}</div>
                </div>
                <ul class="product__data  product__data--sm">
                  <li class="product_data-item" v-if="product.sizes">
                    {{ product.formatted_sizes }}
                  </li>
                  <li class="product_data-item" v-if="product.weight">
                    {{ product.formatted_weight }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="variations-table__col">
            <ul class="product__data">
              <li class="product_data-item">
                {{ in18['page_availability'] }}
                <span :class="['fw-500 no-wrap', stockStatusClass(product)]">
                    {{ stockStatusText(product) }}
                </span>
              </li>
            </ul>
          </div>

          <div class="variations-table__col">
            <product-price :prices="product.prices" :class-name="'product__price mb-0'"/>
          </div>

          <div class="variations-table__col  text-right">
            <add-to-cart-button
                v-if="product.quantity > 0"
                className="btn  btn--primary  no-wrap  fw-400 !flex justify-center items-center gap-2"
                :product-id="product.id"
                :title="in18['page_add_to_cart']"
                :in18="in18"
            >
              <img alt="" src="/shop/images/add-to-cart.svg">
            </add-to-cart-button>
            <button v-else class="btn  btn--primary-outline  no-wrap  fw-400" type="button"
                    @click="redirectToProduct(product)">
              {{ in18['page_apply_for_notification'] }}
            </button>
          </div>
        </div>
      </div><!-- /.variations-table -->
    </div><!-- /.container -->
  </section>
</template>

<script>
import AddToCartButton from "./AddToCartButton.vue";

export default {
  name: "ProductRelatedManual",
  components: {
    'add-to-cart-button': AddToCartButton,
  },
  props: {
    product: Object,
    theme: {
      type: String,
      default: 'sky', // Options: green, pink, amber, sky
    },
    in18: Object,
  },
  data() {
    return {
      products: [],
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get( `/api/product/related-manual/${this.product.id}`).then((response) => {
        this.products = response.data.products;
      });
    },
    redirectToProduct(product) {
        window.location.href = product.link;
    },
    stockStatusText(product) {
      return product.is_available_for_purchase
          ? this.in18['page_product_in_stock']
          : this.in18['page_out_of_stock'];
    },
    stockStatusClass(product) {
      return product.is_available_for_purchase
          ? 'text-green'
          : 'text-primary';
    },
    splitTitle(string) {
      if (!string) return {};
      const words = string.split(" ");
      const last = words.pop();
      return {
        first: words.join(" "),
        last,
      };
    }
  },
}
</script>
